import { ProcessStepModeSchema, ProcessStep } from "../types";
import { IndustrialProcess } from "../types/IndustrialProcess";

export const mockProcessStep = {
  id: "1",
  companyMachineId: "companyMachineId",
  fixedCost: 0,
  fixedCostPerSeries: 0,
  isFixedCostPerSeries: false,
  machineHourlyPrice: 0,
  machinePreparationTime: 0,
  manHourlyPrice: 0,
  manTime: 0,
  materialLoadTimeMinutes: 0,
  partLoadTimeMinutes: 0,
  toolingCost: 0,
  industrialProcess: IndustrialProcess.LASER_CUT,
  margin: 0,
  productsMarginRatio: 0,
  partsToPackQuantity: 0,
  partsToControlRatio: 0,
  packingHourlyPrice: 0,
  otherMachineTime: 0,
  materialUnloadingTime: 0,
  createdAt: new Date(),
  updatedAt: new Date(),
  mode: ProcessStepModeSchema.enum.TIME,
} as ProcessStep;
